import Page from "~/pages/Page";
import Component from "~/components/Component";
import { initShowHidePassword } from "~/components/ShowHidePassword";
import {domSelectors} from "~/globals";
import * as validation from "~/utils/validation"
import UI from "~/ui";
import * as _ from "~/utils";
import $ from "jquery";
import {getApi, handleError} from "~/auth";
import {generaRecaptcha, recaptchaReady, recaptchaToken} from "~/recaptcha";
import {validatePassword, comparePassword} from "~/utils/password";
import {gotoHome} from "~/utils";
import {t} from "~/hooks/useI18n";

class Register extends Page {

    private theForm: HTMLFormElement = document.getElementById("form-register") as HTMLFormElement;
   
    constructor() {
        super("register", "Registrazione");
    }

    private async initRecaptcha() {
        await recaptchaReady();
        let _ = generaRecaptcha('register', true);
    }

    pageStart(): Promise<void> {
        const that = this;
        initShowHidePassword();
        let _ = this.initRecaptcha();
        that.addValidation();

        $("#btnRegister").on("click", function (e) {
            e.preventDefault();
            that.handleFormSubmit();
        });

        return Promise.resolve();
    }

    private addValidation(): void {
        const that = this;
        const form = this.theForm;

        // Rimuove la classe di validazione quando l'utente modifica i campi
        form.addEventListener("input", () => {
            form.classList.remove("was-validated");
        });

        const inputValidator = (inputElement: HTMLInputElement): validation.ValidationResult => {
            const inputValue = $(inputElement).val() as string;
            const isValid = inputValue.length > 0;

            return {
                ok: isValid,
                error: isValid ? "" : t("validation.required")
            };
        }
        
        // Validatore per l'email
        const emailValidator = (inputElement: HTMLInputElement): validation.ValidationResult => {
            const email = $(inputElement).val() as string;

            // Se il campo è vuoto, restituisci "Campo obbligatorio"
            if (!email || email.length === 0) {
                return {
                    ok: false,
                    error: t("validation.required")
                };
            }

            // Se non è vuoto, valida il formato
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            const isValid = emailRegex.test(email);

            return {
                ok: isValid,
                error: isValid ? "" : t("validation.emailInvalidFormat")
            };
        };

        // Validatore per la password
        const passwordValidator = (inputElement: HTMLInputElement): validation.ValidationResult => {
            const password = $(inputElement).val() as string;

            // Se il campo è vuoto, restituisci "Campo obbligatorio"
            if (!password || password.length === 0) {
                return {
                    ok: false,
                    error: t("validation.required")
                };
            }

            // Se non è vuoto, valida il formato
            const isValid = validatePassword(password);
            return {
                ok: isValid.ok,
                error: isValid.ok ? "" : t("validation.passwordInvalidFormat")
            };
        };

        // Validatore per il confronto delle password
        const compareValidator = (inputElement: HTMLInputElement, compareElement: HTMLInputElement): validation.ValidationResult => {
            const confermaPassword = $(inputElement).val() as string;
            const password = $(compareElement).val() as string;
            const isValid = comparePassword(password, confermaPassword);

            return {
                ok: isValid.ok,
                error: isValid.ok ? "" : t("messages.passwordsDoNotMatch")
            };
        };
        
        const validaNome = () => {
            validation.validate("txtNome", inputValidator);
        }

        const validaCognome = () => {
            validation.validate("txtCognome", inputValidator);
        }
        const validaEmail = () => {
            validation.validate("txtEmail", emailValidator);
        };
        const validaPassword = () => {
            validation.validate("txtPassword", passwordValidator);
        };

        // Funzione per confrontare due campi password
        const comparaPassword = (passwordFieldId: string, confirmPasswordFieldId: string) => {
            const passwordInput = document.getElementById(passwordFieldId) as HTMLInputElement;
            const confirmPasswordInput = document.getElementById(confirmPasswordFieldId) as HTMLInputElement;

            if (passwordInput && confirmPasswordInput) {
                validation.validate(confirmPasswordFieldId, (inputElement) =>
                    compareValidator(inputElement, passwordInput)
                );
            }
        };


        // Imposta i validatori sui campi
        validation.setValidatorOnInput("txtNome", inputValidator);
        validation.setValidatorOnInput("txtCognome", inputValidator);
        validation.setValidatorOnInput("txtEmail", emailValidator);
        validation.setValidatorOnInput("txtPassword", passwordValidator);
        validation.setValidatorOnInput("txtConfirmPassword", (inputElement) =>
            compareValidator(inputElement, document.getElementById("txtPassword") as HTMLInputElement)
        );


        // Validazione al submit
        this.onSubmitValidator = async () => {
            validaNome();
            validaCognome();
            validaEmail();
            validaPassword();
            comparaPassword("txtPassword", "txtConfirmPassword");

            // Scorri al primo errore
            const firstInvalidElement = form.querySelector(".is-invalid");
            if (firstInvalidElement) {
                firstInvalidElement.scrollIntoView({ behavior: "smooth", block: "center" });
                (firstInvalidElement as HTMLElement).focus();
            }
        };
    }

    private onSubmitValidator: () => void = async () => {
    }

    private async handleFormSubmit() {
        const $registerMessage = $(domSelectors.RegisterMessageText);
        
        // Validazione del form
        this.onSubmitValidator();
        if (!this.theForm.checkValidity()) {
            this.theForm.classList.add('was-validated');
            return;
        }

        if (!recaptchaToken) {
            UI.confirmOneButton("", t('messages.recaptchaFailed'));
            return;
        }

        const nome = $("#txtNome").val() as string;
        const cognome = $("#txtCognome").val() as string;
        const email = $("#txtEmail").val() as string;
        const password = $("#txtPassword").val() as string;
        const confermaPassword = $("#txtConfirmPassword").val() as string;

        let consents = $(".form-check.consent input[type=checkbox].form-check-input");
        let formData = {
            clientId: window.WsAuthClientCode,
            nome: nome,
            cognome: cognome,
            email: email,
            password: password,
            confirmPassword: confermaPassword,
            privacyConsents: consents.map((i: number, el: HTMLElement) => {
                let check = el as HTMLInputElement;
                return {
                    id: $(el).data('privacy-id'),
                    code: check.name,
                    granted: check.checked
                }
            }).toArray(),
            callbackUrl: window.BaseUrlWeb + "Home/ConfirmEmail",
        };

        let _ = this.spinner.spin();
        try {
            await getApi().register(formData);
            $registerMessage
                .removeClass("alert-danger")
                .addClass("alert-success")
                .html(t('messages.registrationSuccess'))
                .addClass("show")
                .addClass("d-block")
                .removeClass("d-none");

            $(this.theForm).trigger("reset")
                .css("display", "none") // nascondo l'intero form
                .removeClass("was-validated");

            // scroll to top
            window.scrollTo({ top: 0 });
            
        } catch (authErr) {
            let errHtml = handleError(authErr);

            $registerMessage
                .html(errHtml)
                .addClass(["show", "alert-danger", "d-block"])
                .removeClass(["alert-success", "d-none"])
            
            // scroll to top
            window.scrollTo({ top: 0 });
            
            await generaRecaptcha('register', true);
        } finally {
            this.spinner.stop();
        }

    }

}

export default Register;